import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { Checkbox } from "primereact/checkbox";
import Select from "react-dropdown-select";

function AddNewProject() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [activeLanguage, setActiveLanguage] = useState('en');
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    language: 'en',
    title: '',
    // slug: '',
    featuredImage: null,
    galleryImages: null,
    contentBanner: null,
    type: '',
    ano: '',
    cliente: '',
    location: '',
    lightingDesigner: '',
    interiorDesigner: '',
    photography: '',
    partners: '',
    priorityNumber: '',
    isFeatured: false,
    isHomePageFeatured: false
  });

  const [spanishData, setSpanishData] = useState({
    language: 'es',
    title: '',
    category: [],
    type: '',
    ano: '',
    cliente: '',
    location: '',
    lightingDesigner: '',
    interiorDesigner: '',
    photography: '',
    partners: '',
    centerContent: [],
    contentBanner: ''
  });

  // Category select state
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSpanishCategories, setSelectedSpanishCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    axios.get(`${config.BASE_URL}/api/admin/categories/list`)
      .then((res) => {
        if (res.data?.success) {
          setCategoryOptions(
            (res?.data?.data || []).map((cat) => ({
              label: cat?.name,
              value: cat?._id,
            }))
          );
        }
      })
      .catch((err) => console.error("Failed to fetch categories:", err));

    // Fetch priority data
    const getPriorities = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/get-priority`, { withCredentials: true });
        setMAX_PRIORITY(response?.data?.maxLimit + 1);
        setUsed(response?.data?.used);
        setAvailable(response?.data?.available);
      } catch (err) {
        console.error('Failed to load priorities');
      }
    };

    getPriorities();
  }, []);

  const [centerContent, setCenterContent] = useState([
    { description: '', image: null, isFullWidth: false }
  ]);

  const [spanishCenterContent, setSpanishCenterContent] = useState([
    { description: '', image: null, isFullWidth: false }
  ]);

  // Priority selection states
  const [used, setUsed] = useState([]);
  const [available, setAvailable] = useState([]);
  const [selected, setSelected] = useState(null);
  const [MAX_PRIORITY, setMAX_PRIORITY] = useState(0);

  const handleContentChange = (index, event) => {
    const newFields = centerContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setCenterContent(newFields);
  };

  const handleCheckboxChange = (index, checked) => {
    const newFields = centerContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, "isFullWidth": checked };
      }
      return field;
    });
    setCenterContent(newFields);
  };

  const addContentFields = () => {
    setCenterContent([...centerContent, { description: '', image: null, isFullWidth: false }]);
  };

  const removeContentFields = (index) => {
    const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
    setCenterContent(newFields);
  };

  const handleContentImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = centerContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setCenterContent(newFields);
  };

  // Spanish Center Content handlers
  const handleSpanishContentChange = (index, event) => {
    const newFields = spanishCenterContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setSpanishCenterContent(newFields);
  };

  const handleSpanishCheckboxChange = (index, checked) => {
    const newFields = spanishCenterContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, "isFullWidth": checked };
      }
      return field;
    });
    setSpanishCenterContent(newFields);
  };

  const addSpanishContentFields = () => {
    setSpanishCenterContent([...spanishCenterContent, { description: '', image: null, isFullWidth: false }]);
  };

  const removeSpanishContentFields = (index) => {
    const newFields = spanishCenterContent.filter((field, fieldIndex) => index !== fieldIndex);
    setSpanishCenterContent(newFields);
  };

  const handleSpanishContentImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = spanishCenterContent.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setSpanishCenterContent(newFields);
  };

  // Priority selection handlers
  const handleSelect = (number) => {
    if (used.includes(number)) return; // ignore used numbers
    setSelected(number);
  };

  const unsetPriority = () => {
    setSelected(null);
  };

  const getButtonClasses = (number) => {
    const isUsed = used.includes(number);
    const isSelected = selected === number;

    let classes = 'w-10 h-10 rounded text-sm font-semibold transition-colors duration-150';

    if (isUsed) {
      classes += ' bg-gray-300 text-gray-500 cursor-not-allowed';
    } else if (isSelected) {
      classes += ' bg-blue-500 text-white';
    } else {
      classes += ' bg-green-100 hover:bg-green-200 text-green-800';
    }

    return classes;
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };

  const handleSpanishInputChange = (e) => {
    const { name, value } = e.target;
    setSpanishData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append('image', image);

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data?.image; // Assuming your API returns the image URL
    } catch (error) {
      console.error('Image upload failed:', error);
      return null;
    }
  };

  const handleAddLocation = async (e) => {
    e.preventDefault();
    const data = new FormData();
    // Base (English) fields
    data.append('language', formData.language);
    data.append('title', formData.title);
    // data.append('slug', formData.slug);
    data.append('type', formData.type);
    data.append('ano', formData.ano);
    // Append categories as multiple fields so Express parses array correctly
    if (selectedCategories && selectedCategories.length > 0) {
      selectedCategories.forEach((cat) => {
        const value = typeof cat === 'string' ? cat : (cat?.value || cat?.label);
        if (value) data.append('category', value);
      });
    }
    data.append('cliente', formData.cliente);

    data.append('location', formData?.location);
    data.append('lightingDesigner', formData.lightingDesigner);
    data.append('interiorDesigner', formData.interiorDesigner);
    data.append('photography', formData.photography);
    data.append('partners', formData.partners);
    if (selected !== null) {
      data.append('priorityNumber', selected);
    }
    data.append('isFeatured', formData.isFeatured);
    data.append('isHomePageFeatured', formData.isHomePageFeatured);

    // Handle multiple file uploads for images
    if (formData.galleryImages) {
      for (let i = 0; i < formData.galleryImages.length; i++) {
        data.append('galleryImages', formData.galleryImages[i]);
      }
    }
    // Single file upload for featured image
    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    if (formData.contentBanner) {
      data.append('contentBanner', formData.contentBanner[0]);
    }

    // English Center Content
    let updatedCenterContent = [];
    if (centerContent.length > 0) {
      await Promise.all(centerContent.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image === "object") {
            const imageData = await handleImageUpload(item?.image);
            updatedCenterContent.push({ description: item.description, image: imageData, isFullWidth: item.isFullWidth });
          } else {
            updatedCenterContent.push({ description: item.description, image: item?.image, isFullWidth: item.isFullWidth });
          }
        } else {
          updatedCenterContent.push({ description: item.description, image: null, isFullWidth: item.isFullWidth });
        }
      }));
      data.append('centerContent', JSON.stringify(updatedCenterContent));
    }

    // Spanish Center Content
    let updatedSpanishCenterContent = [];
    if (spanishCenterContent.length > 0) {
      await Promise.all(spanishCenterContent.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image === "object") {
            const imageData = await handleImageUpload(item?.image);
            updatedSpanishCenterContent.push({ description: item.description, image: imageData, isFullWidth: item.isFullWidth });
          } else {
            updatedSpanishCenterContent.push({ description: item.description, image: item?.image, isFullWidth: item.isFullWidth });
          }
        } else {
          updatedSpanishCenterContent.push({ description: item.description, image: null, isFullWidth: item.isFullWidth });
        }
      }));
      data.append('spanishCenterContent', JSON.stringify(updatedSpanishCenterContent));
    }

    // Prepare categories arrays
    const selectedCategoryValues = (selectedCategories || []).map((cat) => (
      typeof cat === 'string' ? cat : (cat?.value || cat?.label)
    )).filter(Boolean);

    const selectedSpanishCategoryValues = (selectedSpanishCategories || []).map((cat) => (
      typeof cat === 'string' ? cat : (cat?.value || cat?.label)
    )).filter(Boolean);

    // Spanish translation
    data.append('spanishData', JSON.stringify({
      language: 'es',
      title: spanishData.title || '',
      category: selectedSpanishCategoryValues,
      type: spanishData.type || '',
      ano: spanishData.ano || '',
      cliente: spanishData.cliente || '',

      location: spanishData?.location || '',
      lightingDesigner: spanishData.lightingDesigner || '',
      interiorDesigner: spanishData.interiorDesigner || '',
      photography: spanishData.photography || '',
      partners: spanishData.partners || '',
      centerContent: updatedSpanishCenterContent,
      contentBanner: spanishData.contentBanner || ''
    }));

    try {
      setLoading(true);
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-project`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/dashboard');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add project');
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button
                type="button"
                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                onClick={() => setActiveLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                English
              </button>
              <button
                type="button"
                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                onClick={() => setActiveLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleAddLocation} encType="multipart/form-data">
              <div className="language-content">
                {/* English Content */}
                {activeLanguage === 'en' && (
                  <div className="language-content">
                    <h3>English Content</h3>
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div>
                    {/* <div className="add_field titleField">
                      <h2>Slug (English)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="url-friendly-slug"
                        required
                      />
                    </div> */}
                    {/* <div className="add_field textareaField">
                      <h2>Type (English)</h2>
                      <input
                        type="text"
                        name="type"
                        value={formData.type}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div> */}
                    <div className="add_field textareaField">
                      <h2>Ano (English)</h2>
                      <input
                        type="text"
                        name="ano"
                        value={formData.ano}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Cliente (English)</h2>
                      <input
                        type="text"
                        name="cliente"
                        value={formData.cliente}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Location (English)</h2>
                      <input
                        type="text"
                        name="location"
                        value={formData?.location}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Lighting Designer (English)</h2>
                      <input
                        type="text"
                        name="lightingDesigner"
                        value={formData.lightingDesigner}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Interior Designer (English)</h2>
                      <input
                        type="text"
                        name="interiorDesigner"
                        value={formData.interiorDesigner}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Photography (English)</h2>
                      <input
                        type="text"
                        name="photography"
                        value={formData.photography}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Partners (English)</h2>
                      <input
                        type="text"
                        name="partners"
                        value={formData.partners}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>
                    {/* <div className="add_field textareaField">
                      <h2>Priority Number</h2>
                      <input
                        type="number"
                        name="priorityNumber"
                        value={formData.priorityNumber}
                        onChange={(e) => handleInputChange(e.target)}
                        min="0"
                      />
                    </div> */}
                  </div>
                )}

                {/* Spanish Content */}
                {activeLanguage === 'es' && (
                  <div className="language-content">
                    <h3>Spanish Content</h3>
                    <div className="add_field titleField">
                      <h2>Title (Spanish)</h2>
                      <input
                        type="text"
                        name="title"
                        value={spanishData.title}
                        onChange={handleSpanishInputChange}
                        placeholder="Título"
                      />
                    </div>
                    {/* <div className="add_field titleField">
                      <h2>Slug (Spanish)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={spanishData.slug}
                        onChange={handleSpanishInputChange}
                        placeholder="slug-amigable"
                      />
                    </div> */}
                    <div className="add_field textareaField">
                      <h2>Type (Spanish)</h2>
                      <input
                        type="text"
                        name="type"
                        value={spanishData.type}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Ano (Spanish)</h2>
                      <input
                        type="text"
                        name="ano"
                        value={spanishData.ano}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Cliente (Spanish)</h2>
                      <input
                        type="text"
                        name="cliente"
                        value={spanishData.cliente}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Location (Spanish)</h2>
                      <input
                        type="text"
                        name="location"
                        value={spanishData?.location}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Lighting Designer (Spanish)</h2>
                      <input
                        type="text"
                        name="lightingDesigner"
                        value={spanishData.lightingDesigner}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Interior Designer (Spanish)</h2>
                      <input
                        type="text"
                        name="interiorDesigner"
                        value={spanishData.interiorDesigner}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Photography (Spanish)</h2>
                      <input
                        type="text"
                        name="photography"
                        value={spanishData.photography}
                        onChange={handleSpanishInputChange}
                      />
                    </div>
                    <div className="add_field textareaField">
                      <h2>Partners (Spanish)</h2>
                      <input
                        type="text"
                        name="partners"
                        value={spanishData.partners}
                        onChange={handleSpanishInputChange}
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Categories (Spanish)</h2>
                      <Select
                        options={categoryOptions}
                        multi
                        searchable
                        labelField="label"
                        valueField="value"
                        placeholder="Seleccionar categorías"
                        values={selectedSpanishCategories}
                        onChange={(values) => setSelectedSpanishCategories(values)}
                      />
                    </div>

                    <div className="add_field textareaField repeaterFields">
                      <h2>Center Content (Spanish)</h2>
                      {spanishCenterContent.map((field, index) => (
                        <div key={index} className="singleReapterFieldContent">
                          <div className="add_field">
                            <h2>Description</h2>
                            <input
                              name="description"
                              type="text"
                              value={field.description}
                              placeholder="Descripción"
                              onChange={(event) => handleSpanishContentChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h2>Image</h2>
                            <div className="form-group">
                              <div className="file-upload">
                                <input
                                  type="file"
                                  className="form-control"
                                  name="image"
                                  onChange={(event) => handleSpanishContentImageChange(index, event)}
                                  multiple
                                />
                                <i className="fa fa-camera i-pic-upload"></i>
                              </div>
                            </div>
                          </div>

                          <div className="add_field checkbox_field">
                            <h2>Is Full Width?</h2>
                            <Checkbox
                              onChange={e => handleSpanishCheckboxChange(index, e.checked)}
                              checked={field?.isFullWidth}
                            ></Checkbox>
                          </div>

                          <button type="button" onClick={() => removeSpanishContentFields(index)}>
                            Remove
                          </button>
                        </div>
                      ))}
                      <button type="button" onClick={addSpanishContentFields}>Add More</button>
                    </div>
                  </div>
                )}

                {activeLanguage === 'en' && (<div className="add_field textareaField">
                  <h2>Categories</h2>
                  <Select
                    options={categoryOptions}
                    multi
                    searchable
                    labelField="label"
                    valueField="value"
                    placeholder="Select categories"
                    values={selectedCategories}
                    onChange={(values) => setSelectedCategories(values)}
                  />
                </div>)}


                {activeLanguage === 'en' && (
                  <div className="add_field textareaField repeaterFields">
                    <h2>Center Content</h2>
                    {centerContent.map((field, index) => (
                      <div key={index} className="singleReapterFieldContent">
                        <div className="add_field">
                          <h2>Description</h2>
                          <input
                            name="description"
                            type="text"
                            value={field.description}
                            placeholder="Description"
                            onChange={(event) => handleContentChange(index, event)}
                          />
                        </div>

                        <div className="add_field">
                          <h2>Image</h2>
                          <div className="form-group">
                            <div className="file-upload">
                              <input
                                type="file"
                                className="form-control"
                                name="image"
                                onChange={(event) => handleContentImageChange(index, event)}
                                multiple
                              />
                              <i className="fa fa-camera i-pic-upload"></i>
                            </div>
                          </div>
                        </div>

                        <div className="add_field checkbox_field">
                          <h2>Is Full Width?</h2>
                          <Checkbox
                            onChange={e => handleCheckboxChange(index, e.checked)}
                            checked={field?.isFullWidth}
                          ></Checkbox>
                        </div>

                        <button type="button" onClick={() => removeContentFields(index)}>
                          Remove
                        </button>
                      </div>
                    ))}
                    <button type="button" onClick={addContentFields}>Add More</button>
                  </div>
                )}

                <div className="add_field">
                  <h2>Gallery Images</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="galleryImages"
                        multiple
                        onChange={(e) => handleInputChange(e.target)}
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>

                <div className="add_field">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>

                <div className="add_field">
                  <h2>Center Content Banner Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="contentBanner"
                        onChange={(e) => handleInputChange(e.target)}
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>

                <div className="add_field checkbox_field">
                  <Checkbox
                    onChange={(e) => setFormData({ ...formData, isFeatured: e.checked })}
                    checked={formData.isFeatured}
                    required={formData?.isHomePageFeatured && !formData?.isFeatured ? true : false}

                  ></Checkbox>

                  <h4>Is Featured?</h4>
                </div>
                <span style={{color:'red'}}>{formData?.isHomePageFeatured && !formData?.isFeatured ? "A HomePage Featured project must also be marked as Featured. " : ''}</span>
                <div className="add_field checkbox_field">
                  <Checkbox
                    onChange={(e) => setFormData({ ...formData, isHomePageFeatured: e.checked })}
                    checked={formData.isHomePageFeatured}
                  ></Checkbox>
                  <h4>Is HomePage Featured?</h4>
                </div>
              </div>

              <div className="add_project">
                {/* <button type="submit">Add Project</button> */}
                <button type="submit" disabled={loading}>
                  {loading ? 'Submitting...' : 'Add Project'}
                </button>

              </div>

            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewProject;
